import React from 'react';
import { useLocation } from 'react-router';
const PasswordReset = () => {
    const location = useLocation();
    const userEmail = location.state.userEmail;
    
    return (
        <div className="container text-center">
           {
               userEmail ?  <h2>We have sent you an email at <strong className="text-info">{userEmail}</strong> regarding your password reset issue</h2> :
               <h2>Please first write your email address in the email input field</h2>
           }
          
        </div>
    );
};

export default PasswordReset;